import api from '@/utils/api';

/**
 * Update Company Product Category Order
 * @param {string} id Company id
 * @param {object} data - The CompanyProduct order data
 * @param {string} data.id Product Category id
 * @param {string} data.order Order
 * @returns {Promise}
 */
const updateCompanyProductCategoryOrderApi = (id, data) =>
  api.patch(`/company/${id}/product-category/order`, data);

export default updateCompanyProductCategoryOrderApi;
